import { render, staticRenderFns } from "./Lianxi.vue?vue&type=template&id=61449186&scoped=true&"
import script from "./Lianxi.vue?vue&type=script&lang=js&"
export * from "./Lianxi.vue?vue&type=script&lang=js&"
import style0 from "./Lianxi.vue?vue&type=style&index=0&id=61449186&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61449186",
  null
  
)

export default component.exports